<template>
  <div class="card">
    <div class="card__left">
      <img :src="product.product.images.edges[0].node.image" :alt="product.product.name">
      <div class="card__left-inner">
        <p class="card__left-name">{{ product.product.name }}</p>
        <p class="card__left-text">{{ product.product.category.name }}</p>
        <p class="card__left-text">€ {{ product.product.price }}</p>
      </div>
    </div>
    <div class="card__right">
      <div class="card__manage">
        <p class="card__manage-count">{{ product.quantity }}</p>
        <div class="card__manage-buttons">
          <svg @click="addToCart" width="26" viewBox="0 0 26 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.541 9.46278L13.1367 0.326355L0.732422 9.46278H25.541Z" fill="currentColor"/>
          </svg>
          <svg @click="removeProductFormCart" width="26" viewBox="0 0 26 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.541 0.508227L13.1367 9.64465L0.732422 0.508227H25.541Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <svg @click="removeAllProductFormCart" class="card__right-remove" fill="currentColor" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M831.24 280.772c5.657 0 10.24-4.583 10.24-10.24v-83.528c0-5.657-4.583-10.24-10.24-10.24H194.558a10.238 10.238 0 00-10.24 10.24v83.528c0 5.657 4.583 10.24 10.24 10.24H831.24zm0 40.96H194.558c-28.278 0-51.2-22.922-51.2-51.2v-83.528c0-28.278 22.922-51.2 51.2-51.2H831.24c28.278 0 51.2 22.922 51.2 51.2v83.528c0 28.278-22.922 51.2-51.2 51.2z"></path>
          <path d="M806.809 304.688l-58.245 666.45c-.544 6.246-6.714 11.9-12.99 11.9H290.226c-6.276 0-12.447-5.654-12.99-11.893L218.99 304.688c-.985-11.268-10.917-19.604-22.185-18.619s-19.604 10.917-18.619 22.185l58.245 666.45c2.385 27.401 26.278 49.294 53.795 49.294h445.348c27.517 0 51.41-21.893 53.796-49.301l58.244-666.443c.985-11.268-7.351-21.201-18.619-22.185s-21.201 7.351-22.185 18.619zM422.02 155.082V51.3c0-5.726 4.601-10.342 10.24-10.342h161.28c5.639 0 10.24 4.617 10.24 10.342v103.782c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V51.3c0-28.316-22.908-51.302-51.2-51.302H432.26c-28.292 0-51.2 22.987-51.2 51.302v103.782c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48z"></path>
          <path d="M496.004 410.821v460.964c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V410.821c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48zm-192.435 1.767l39.936 460.964c.976 11.269 10.903 19.612 22.171 18.636s19.612-10.903 18.636-22.171l-39.936-460.964c-.976-11.269-10.903-19.612-22.171-18.636s-19.612 10.903-18.636 22.171zm377.856-3.535l-39.936 460.964c-.976 11.269 7.367 21.195 18.636 22.171s21.195-7.367 22.171-18.636l39.936-460.964c.976-11.269-7.367-21.195-18.636-22.171s-21.195 7.367-22.171 18.636z"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script setup>
import {Orders} from "@/core/api/orders.js";
import {ElNotification} from "element-plus";
import {computed} from "vue";
import {useCartStore} from "@/stores/cart.js";
import {useAuthStore} from "@/stores/auth.js";
import {useI18n} from "vue-i18n";

const props = defineProps({
  product: Object
})

const {t} = useI18n()
const cartStore = useCartStore()
const authStore = useAuthStore()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder.uuid ? cartStore.currentOrder.uuid : null
})

const isProductInCart = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.find((prod) => prod.node.product.uuid === props.product.product.uuid)
})
const productQuantity = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.filter((prod) => prod.node.product.uuid === props.product.product.uuid)[0]?.node.quantity
})

const addToCart = async () => {
  if (isProductInCart.value) {
    if (props.product.product.quantity > productQuantity.value) {
      const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);
      cartStore.setCurrentOrders(res.data.addOrderProduct.order)

      if (res.errors) {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      } else {
        ElNotification({
          message: t('popup.addToCart', { product: props.product.product.name }),
          type: "success"
        });
      }
    } else {
      ElNotification({
        message: t('popup.addToCartLimit', { quantity: props.product.product.quantity }),
        type: "error"
      });
    }
  } else {
    const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);
    cartStore.setCurrentOrders(res.data.addOrderProduct.order)

    if (res.errors) {
      ElNotification({
        message: res.errors[0].message,
        type: "error"
      });
    } else {
      ElNotification({
        message: t('popup.addToCart', { product: props.product.product.name }),
        type: "success"
      });
    }
  }
}

const removeProductFormCart = async () => {
  if (productQuantity.value === 1) {
    await removeAllProductFormCart()
    return
  }

  const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, props.product.product.uuid);

  cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
}

const removeAllProductFormCart = async () => {
  const res = await Orders.overwriteCart("removeOrderProductsOfAKind", accessToken.value, orderUuid.value, props.product.product.uuid);
  cartStore.setCurrentOrders(res.data.removeOrderProductsOfAKind.order)
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 15px;
  border: 2px solid $black;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__left {
    display: flex;
    align-items: center;
    gap: 30px;

    & img {
      width: 140px;
      border-radius: 15px;
    }

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    &-name {
      font-family: Poppins, sans-serif;
      font-size: 26px;
      font-weight: 500;
      color: $black;
    }

    &-text {
      font-family: Nunito, sans-serif;
      font-size: 20px;
      font-weight: 500;
      color: $black;
    }
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 30px;

    &-remove {
      cursor: pointer;
      width: 50px;
    }
  }

  &__manage {
    display: flex;
    align-items: center;
    gap: 5px;

    &-count {
      font-family: Raleway, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #393939;
    }

    &-buttons {
      display: flex;
      flex-direction: column;
      gap: 2px;

      & img {
        cursor: pointer;
        width: 32px;
        color: $black;

        @include hover {
          color: #424242;
        }
      }

      & svg {
        cursor: pointer;
        transition: 0.2s;
        color: #393939;

        @include hover {
          color: #868686;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .card {
    &__left {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;

      &-inner {
        gap: 5px;
      }
    }
  }
}

@media (max-width: 450px) {
  .card {
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &__left {
      align-items: center;

      &-name {
        text-align: center;
        font-size: 20px;
      }

      &-text {
        text-align: center;
        font-size: 16px;
      }
    }

    &__right {
      &-remove {
        width: 30px;
      }
    }
  }
}
</style>